import { h } from 'preact';
import { Link } from 'preact-router/match';
import style from './style.css';
import { logout } from '../components/authentication';

const Header = () => (
	<header class={style.header}>
		<a href="/" class={style.logo}>
			<img src="../../assets/WhosApp_1024.png" alt="Preact Logo" height="32" width="32" />
			<h1>WhosApp</h1>
		</a>
		<nav>
			<Link activeClassName={style.active} href="/login">
				Login
			</Link>
			<button
				type="button"
				onClick={logout}
				style={{
					background: 'none',
					paddingLeft: '1rem',
					paddingRight: '1rem',
					border: 'none',
					color: 'inherit',
					font: 'inherit',
					cursor: 'pointer',
					outline: 'none',
				}}
			>
				Logout
			</button>
			<Link activeClassName={style.active} href="/">
				Home
			</Link>
		</nav>
	</header>
);

export default Header;
